import { Component } from '@angular/core';

@Component({
    selector: 'app-info-button',
    templateUrl: './info-button.component.html',
    standalone: false
})
export class InfoButtonComponent {
  isOpen = false;

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  close(): void {
    this.isOpen = false;
  }
}
